<div class="min-h-screen bg-e-white">
  <div class="container-default flex px-6 pt-6 pb-0 md:pb-6">
    <div class="flex flex-col w-full md:w-auto">
      <small class="flex flex-row flex-wrap md:my-6">
        <ng-template #breadcrumbtext><span class="col-auto ps-0">{{'allrecipes.allrecipes' |translate}} </span></ng-template>
        @if (displaytype !== 'LIST') {
          <a class="pr-[5px]" [routerLink]="'/recipes'">{{'allrecipes.allrecipes' |translate}}</a>
        } @else {
          <span class="col-auto ps-0">{{'allrecipes.allrecipes' |translate}} </span>
        }
        @if (displaytype === 'LIFESTYLE' && shownLifestyle) {
          <span class="pr-[5px]">></span> <span class="col-auto ps-0 ">{{shownLifestyle?.name | capitalizefirst}} {{'recipe.recipes' | translate| lowercase}}</span>
        }
        @if (displaytype !== 'LIFESTYLE' && shownLifestyle) {
          <span class="pr-[5px]">></span> <a [routerLink]="'/recipes/' + shownLifestyle.name.replace(' ', '-').toLowerCase()" class="col-auto ps-0 ">{{shownLifestyle?.name | capitalizefirst}} {{'recipe.recipes' | translate| lowercase}}</a>
        }
        @if (displaytype === 'RECIPESEARCH') {
          <span class="pr-[5px]">></span> <span class="col-auto ps-0 text-capitalize-first">{{'recipesearch.results_for' | translate}} {{searchedValue.value}}</span>
        }
        @if (displaytype === 'INGREDIENTSEARCH') {
          <span class="pr-[5px]">></span> <span class="col-auto ps-0 text-capitalize-first">{{'recipesearch.results_for_ingredientsearch' | translate}}</span>
        }
      </small>
      <app-toggle [(ngModel)]="ingredientSearchActive"> {{'recipesearch.search_by_ingredient' | translate}}</app-toggle>
      @if (!ingredientSearchActive) {
        <div @collapse>
          <div class="form-field">
            <label>{{'recipe.search_recipe' | translate}}</label>
            <input type="text" [formControl]="searchRecipe" (keydown.enter)="onEnter()" />
            <span>@if (recipeSearchLoading && searchRecipe.value?.length >= 2) {
              <app-loader diameter="25"></app-loader>
            }</span>
            @if (!recipeSearchLoading && searchRecipe.value?.length >= 2) {
              <button class="absolute right-[15px] top-[45px] z-[1]" (click)="searchRecipe.setValue(null); onEnter();"><i class="bi bi-x-lg"></i></button>
            }
          </div>
        </div>
      }

      @if (ingredientSearchActive) {
        <div @collapse>
          <div class="form-field ">
            <label>{{'recipesearch.search_by_ingredient' | translate}}</label>
            <input type="text" placeholder="{{'recipesearch.add_ingredient' |translate}}" #fruitInput [formControl]="ingredientCtrl" (keydown.enter)="add()">
          </div>
          <div class="flex flex-row flex-wrap gap-2 mt-2">
            @for (ingredient of ingredients.value; track ingredient) {
              <app-chip [clickable]="false">
                {{ingredient}}<button (click)="remove(ingredient)"><i class="bi bi-x"></i></button>
              </app-chip>
            }
          </div>
        </div>
      }
    </div>
  </div>

  <div class="container-default flex px-6 pb-6 pt-0 md:pt-6 overflow-hidden">
    <div class="w-full">
      <p class="hidden md:block">{{'allrecipes.recipes_per_lifestyle' | translate}}</p>
      <div class="hidden md:flex flex-row flex-wrap mb-4 gap-2">
        @for (style of lifestyles ; track style; let i = $index) {
          <a [routerLink]="shownLifestyle?.id === style.id? '/recipes': '/recipes/'+ style.name.replace(' ', '-').toLowerCase()" queryParamsHandling="merge">
            <app-chip colorscheme="contrast" [selected]="shownLifestyle?.id === style.id" id="lifestyle-{{i}}">
              {{style.name | capitalizefirst}} {{'recipe.recipes' | translate | lowercase}}
            </app-chip>
          </a>
        }
      </div>
      <div class="form-field md:hidden w-full">
        <label>{{'allrecipes.recipes_per_lifestyle' | translate}}</label>
        <select [(ngModel)]="shownLifestyleid" class="w-full" (change)="navigateToLifestyle()">
          <option [value]="null">{{'common.all' |translate}}</option>
          @for (style of lifestyles ; track style; let i = $index) {
            <option [value]="style.id">
              {{style.name | capitalizefirst}} {{'recipe.recipes' | translate | lowercase}}
            </option>
          }
        </select>
      </div>
      <p class="hidden mt-4 md:block">{{'allergen.allergens' | translate}}</p>
      <div class="hidden md:flex flex-row flex-wrap gap-2">
        @for (allergen of allergens; track allergen; let i = $index) {
          <app-chip colorscheme="contrast" (click)="toggleAllergen(allergen)" [selected]="isActiveAllergen(allergen)" id="allergen-{{i}}">
            {{'allergen.' + allergen | translate}}
          </app-chip>
        }
      </div>
      <div class="mt-4 md:hidden">
        <app-allergenselect [formControl]="allergensCtrl" ></app-allergenselect>
      </div>

    </div>
  </div>

  @switch (displaytype) {
    @case ('LIFESTYLE') {
      <div class="container-default flex flex-col justify-center mb-3 mt-3 p-6">
        <h1>
          <!-- has a fallback if there isnt a translation set -->
          <ng-container #translatetitle>{{'allrecipes.title_' + shownLifestyle?.id | translate | capitalizefirst}}</ng-container>
        </h1>
        <div>
          <!-- has a fallback if there isnt a translation set -->
          <ng-container #translatetext>{{'allrecipes.' + shownLifestyle?.id | translate | capitalizefirst}}</ng-container>
        </div>
      </div>
      <div class="row mt-3 mb-3 justify-center">
        <ng-container *ngTemplateOutlet="lifestylebar;context:{lifestyle:shownLifestyle, lifestyleslist:false}"></ng-container>
      </div>
    }
    @case ('RECIPESEARCH') {
      <div class="row justify-content-center mb-3 mt-5 ">
        <div class="container-default">
          <h1>{{'recipesearch.results_for' | translate}} {{searchedValue.value}}</h1>
        </div>
      </div>
      <div class="row mt-3 mb-3 justify-center">
        <ng-container *ngTemplateOutlet="lifestylebar;context:{lifestyle:shownLifestyle, lifestyleslist:false}"></ng-container>
      </div>
    }
    @case ('INGREDIENTSEARCH') {
      <div class="row justify-content-center mb-3 mt-5 ">
        <div class="container-default">
          <h1>{{'recipesearch.results_for_ingredientsearch' | translate}}</h1>
        </div>
      </div>
      <div class="row mt-3 recipes mb-3 justify-content-center">
        <ng-container *ngTemplateOutlet="lifestylebar;context:{lifestyle:shownLifestyle, lifestyleslist:false}"></ng-container>
      </div>
    }
    @case ('LIST') {
      <div class="container-default md:p-6 mt-5">
        <h1>{{'allrecipes.allrecipes'| translate}}</h1>
        <div class="col-auto">{{'allrecipes.subtext'| translate}}</div>
      </div>
      @for (lifestyle of lifestyles; track lifestyle) {
        <div class="container-default">
          <div class="flex flex-row flex-wrap items-center justify-between mb-6 md:mb-0 md:p-6">
            <h2>
              <!-- has a fallback if there isnt a translation set -->
              <ng-container #translatetitle2>{{'allrecipes.title_' + lifestyle?.id | translate | capitalizefirst}}</ng-container>
              <!--<ng-container *ngIf="translatetitle2.previousSibling.data === ''">{{lifestyle.name | capitalizefirst}} {{'recipe.recipes' | translate}}</ng-container>-->
            </h2>
            <a class="chip bg-white rounded-full" [routerLink]="'/recipes/' + lifestyle.name.replace(' ', '-').toLowerCase()" queryParamsHandling="merge">{{'allrecipes.showall' |translate}} {{lifestyle.name}} {{'recipe.recipes' | translate}}</a>
          </div>
          <ng-container *ngTemplateOutlet="lifestylebar;context:{lifestyle:lifestyle, lifestyleslist:true}"></ng-container>
        </div>
      }
    }
  }

  <ng-template #lifestylebar let-lifestyle="lifestyle" let-lifestyleslist="lifestyleslist">
    <div class="container-default relative flex flex-col p-6 bg-e-white" #recipelist>

      <recipe-list class="overflow-x-auto"
        [cols]="4"
        [horizontal]="displaytype === 'LIST'"
        [recipes]="recipes"
        (shownRecipesChange)="shownRecipeCnt = $event.length"
        [lifestyles]="[lifestyle?.id]"
        [scrollload]="!lifestyleslist"
        (scrollloadChange)="loadNextRecipes()"
        [pagesize]="5"
        [loading]="recipesloading"
        [allergens]="allergensCtrl.value"
        id="recipelist-{{lifestyle?.id}}">
        <ng-template #recipe let-recipe>
          <recipecard [recipe]="recipe"
            [status]="'PROCESSED'"
            class="flex items-stretch snap-center min-w-[340px]"
            [selectedallergens]="allergensCtrl.value">
          </recipecard>
        </ng-template>
      </recipe-list>

      <!-- nothing found -->
      @if (shownRecipeCnt === 0 && !recipesloading) {
        <div class="flex flex-col mt-5 mb-5 justify-center" id="busychef">
          <img alt="Nothing here exept a egg" class="max-h-[75px]" src="assets/images/icons/lifestyle/icon_leefstijl_13.svg" />
          @if (displaytype === 'RECIPESEARCH') {
            <span class="ms-4 me-4 mb-5 text-center block mt-3">{{'recipesearch.no_menu_with_this_name'| translate}}</span>
          }
          @if (displaytype === 'INGREDIENTSEARCH') {
            <span class="ms-4 me-4 mb-5 text-center block mt-3">{{'recipesearch.no_menu_with_these_ingredients'| translate}}</span>
          }
        </div>
      }
    </div>

  </ng-template>


  <!-- template for the bottom drawer dialog -->
  <ng-template #bottomdrawer>
    <div class="flex flex-row justify-center p-[15px] rounded-lg bg-white min-w-[300px]">
      <a class="button-base rounded-full" routerLink="/{{'singleorder.organicwebshop_url' |translate}}">
        <span>{{'singleorder.goto_webshop' | translate}}</span>
      </a>
    </div>
  </ng-template>
</div>

<span class="hidden border-e-dark-green md:grid-cols-2 lg:grid-cols-3 grid-cols-4 bg-e-reg-green opacity-50"></span>

<app-footer></app-footer>
